export const GridIcon = ({ size = 24, color = "currentColor" }) => {
  return (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2 0.666992H44C45.841 0.666992 47.333 2.15905 47.333 4V43.667C47.3328 45.6918 45.6918 47.3328 43.667 47.333H3C1.71134 47.333 0.666992 46.2887 0.666992 45V2C0.666993 1.26362 1.26362 0.666992 2 0.666992Z"
        fill="#1C2233"
        stroke="#303547"
        stroke-width="1.33333"
      />
      <rect
        x="12"
        y="12"
        width="10.6667"
        height="10.6667"
        rx="1.33333"
        fill="#8F9299"
      />
      <rect
        x="25.3333"
        y="12"
        width="10.6667"
        height="10.6667"
        rx="1.33333"
        fill="#8F9299"
      />
      <rect
        x="12"
        y="25.3333"
        width="10.6667"
        height="10.6667"
        rx="1.33333"
        fill="#8F9299"
      />
      <rect
        x="25.3333"
        y="25.3333"
        width="10.6667"
        height="10.6667"
        rx="1.33333"
        fill="#8F9299"
      />
    </svg>
  );
};

export const AssetsAddIcon1 = ({ size = 24, color = "currentColor" }) => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="7.33325"
        y="0.333334"
        width="4"
        height="17.3333"
        fill="#9197A4"
      />
      <rect
        x="0.666626"
        y="11"
        width="4"
        height="17.3333"
        transform="rotate(-90 0.666626 11)"
        fill="#9197A4"
      />
    </svg>
  );
};

export const DropDownIcon1 = ({ size = 24, color = "currentColor" }) => {
  return (
    <svg
      width="14"
      height="9"
      viewBox="0 0 14 9"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.4258 0.761902H6.43353H1.0376C0.114239 0.761902 -0.347442 1.87763 0.306606 2.53169L5.28894 7.51399C6.08727 8.31232 7.38574 8.31232 8.18406 7.51399L10.0789 5.61918L13.1664 2.53169C13.8108 1.87763 13.3491 0.761902 12.4258 0.761902Z"
        fill="#888"
      />
    </svg>
  );
};

export const VerifyIcon = ({ size = 24, color = "currentColor" }) => {
  return (
    <svg
      width="23"
      height="23"
      viewBox="0 0 23 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M11.5001 1.44324C17.0566 1.44324 21.5627 5.9494 21.5627 11.5058C21.5627 17.0623 17.0566 21.5685 11.5001 21.5685C5.94366 21.5685 1.4375 17.0623 1.4375 11.5058C1.4375 5.9494 5.94366 1.44324 11.5001 1.44324ZM9.41048 14.7743L6.94691 12.3086C6.5272 11.8887 6.52711 11.2039 6.94691 10.784C7.36679 10.3642 8.05467 10.3668 8.47149 10.784L10.2083 12.5222L14.5289 8.20157C14.9488 7.78169 15.6337 7.78169 16.0535 8.20157C16.4733 8.62136 16.4727 9.30686 16.0535 9.72615L10.9694 14.8103C10.5501 15.2295 9.86457 15.2301 9.44477 14.8103C9.43298 14.7985 9.4216 14.7865 9.41048 14.7743Z"
        fill="#009A2D"
      />
    </svg>
  );
};

export const CameraIcon = ({ size = 24, color = "currentColor" }) => {
  return (
    <svg
      width="22"
      height="17"
      viewBox="0 0 22 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20.2734 2.27319H14.4851L13.3163 0.309606C13.2019 0.117623 12.995 0 12.7716 0H9.09548C8.87205 0 8.66512 0.117623 8.55084 0.309606L7.38201 2.27319H5.48261V1.84041C5.48261 1.49039 5.19883 1.20662 4.84881 1.20662H2.50367C2.15358 1.20662 1.86987 1.49039 1.86987 1.84041V2.27319H1.59378C0.713495 2.27319 0 2.98676 0 3.86691V15.4062C0 16.2864 0.713495 17 1.59371 17H20.2734C21.1536 17 21.8672 16.2864 21.8672 15.4062V3.86691C21.8672 2.98676 21.1536 2.27319 20.2734 2.27319ZM10.9335 14.1731C8.4281 14.1731 6.39705 12.142 6.39705 9.63649C6.39705 7.13111 8.4281 5.09999 10.9335 5.09999C13.439 5.09999 15.47 7.13111 15.47 9.63649C15.47 12.142 13.439 14.1731 10.9335 14.1731ZM19.279 5.55896H17.293C16.943 5.55896 16.6592 5.27518 16.6592 4.92509C16.6592 4.57499 16.943 4.29122 17.293 4.29122H19.279C19.6292 4.29122 19.9129 4.57499 19.9129 4.92509C19.9129 5.27518 19.6291 5.55896 19.279 5.55896Z"
        fill="#8E9199"
      />
      <path
        d="M10.9348 12.8057C12.6851 12.8057 14.104 11.3868 14.104 9.63649C14.104 7.88619 12.6851 6.46729 10.9348 6.46729C9.18453 6.46729 7.76562 7.88619 7.76562 9.63649C7.76562 11.3868 9.18453 12.8057 10.9348 12.8057Z"
        fill="#8E9199"
      />
    </svg>
  );
};

export const CopyIcon = ({ size = 24, color = "currentColor" }) => {
  return (
    <svg
      width="15"
      height="17"
      viewBox="0 0 15 17"
      fill="#888"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.99805 17H2.65625C1.19155 17 0 15.8084 0 14.3438V5.3457C0 3.881 1.19155 2.68945 2.65625 2.68945H8.99805C10.4627 2.68945 11.6543 3.881 11.6543 5.3457V14.3438C11.6543 15.8084 10.4627 17 8.99805 17ZM2.65625 4.01758C1.92397 4.01758 1.32812 4.61342 1.32812 5.3457V14.3438C1.32812 15.076 1.92397 15.6719 2.65625 15.6719H8.99805C9.73033 15.6719 10.3262 15.076 10.3262 14.3438V5.3457C10.3262 4.61342 9.73033 4.01758 8.99805 4.01758H2.65625ZM14.3105 12.6836V2.65625C14.3105 1.19155 13.119 0 11.6543 0H4.2832C3.91641 0 3.61914 0.297272 3.61914 0.664062C3.61914 1.03085 3.91641 1.32812 4.2832 1.32812H11.6543C12.3866 1.32812 12.9824 1.92397 12.9824 2.65625V12.6836C12.9824 13.0504 13.2797 13.3477 13.6465 13.3477C14.0133 13.3477 14.3105 13.0504 14.3105 12.6836Z"
        fill="#F6F6F7"
      />
    </svg>
  );
};

export const TradingHistoryIcon = ({ size = 24, color = "currentColor" }) => {
  return (
    <svg
      width="23"
      height="23"
      viewBox="0 0 23 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_0_280)">
        <path
          d="M13.9556 20.9764C13.7687 21.0229 13.5782 21.0643 13.389 21.0991C12.8946 21.1911 12.5677 21.6666 12.6591 22.1615C12.7043 22.405 12.8426 22.6078 13.0303 22.7402C13.2238 22.8764 13.47 22.9379 13.721 22.8912C13.9462 22.8494 14.1732 22.8002 14.396 22.7446C14.8843 22.6231 15.1817 22.1284 15.0599 21.6404C14.9384 21.152 14.4442 20.8547 13.9556 20.9764Z"
          fill="#9CA1A8"
        />
        <path
          d="M20.6936 8.7623C20.7574 8.95467 20.8793 9.11171 21.0332 9.22022C21.2614 9.38096 21.56 9.43504 21.845 9.34081C22.3228 9.18216 22.5817 8.66695 22.4236 8.1894C22.3516 7.9717 22.2717 7.75331 22.1866 7.54068C21.9997 7.07341 21.4697 6.84592 21.0022 7.03282C20.5351 7.21963 20.3075 7.74981 20.4946 8.21722C20.5661 8.39594 20.6331 8.57939 20.6936 8.7623Z"
          fill="#9CA1A8"
        />
        <path
          d="M16.9171 19.6741C16.7563 19.7802 16.5904 19.8829 16.4233 19.9792C15.9873 20.2307 15.8379 20.7881 16.0893 21.2239C16.1576 21.3424 16.2485 21.4394 16.3532 21.5134C16.6343 21.7112 17.0161 21.7408 17.3339 21.5577C17.5326 21.4431 17.7302 21.3212 17.9216 21.1946C18.3413 20.9173 18.4569 20.352 18.1794 19.9321C17.902 19.512 17.3369 19.3966 16.9171 19.6741Z"
          fill="#9CA1A8"
        />
        <path
          d="M22.9908 11.3071C22.971 10.8042 22.5473 10.4127 22.0443 10.4323C21.5418 10.4522 21.1501 10.8759 21.1698 11.3787C21.1774 11.5709 21.1793 11.766 21.1749 11.958C21.1678 12.2734 21.3221 12.5545 21.5618 12.7235C21.7046 12.8241 21.8779 12.8849 22.0658 12.8892C22.5688 12.9004 22.9856 12.5015 22.9967 11.9983C23.0017 11.7689 22.9998 11.5364 22.9908 11.3071Z"
          fill="#9CA1A8"
        />
        <path
          d="M20.5453 17.277C20.142 16.9744 19.5714 17.0566 19.2694 17.4591C19.1537 17.6133 19.0319 17.7656 18.9072 17.9122C18.5812 18.2951 18.6273 18.8704 19.0102 19.1966C19.0321 19.2151 19.0541 19.2321 19.077 19.2481C19.4578 19.5165 19.9869 19.4548 20.2948 19.0936C20.4437 18.9187 20.5889 18.7368 20.7271 18.5527C21.0292 18.1501 20.9475 17.5791 20.5453 17.277Z"
          fill="#9CA1A8"
        />
        <path
          d="M21.8846 13.9836C21.4044 13.8331 20.8931 14.1004 20.7426 14.5806C20.685 14.764 20.6212 14.9483 20.5523 15.1289C20.401 15.5263 20.5459 15.9635 20.8782 16.1978C20.9392 16.2407 21.0063 16.277 21.0793 16.3045C21.5494 16.4839 22.0759 16.2481 22.2551 15.7777C22.3369 15.5631 22.4128 15.3438 22.4815 15.1257C22.6318 14.6454 22.3647 14.1342 21.8846 13.9836Z"
          fill="#9CA1A8"
        />
        <path
          d="M9.98073 21.1063C9.16605 20.9601 8.38456 20.711 7.64351 20.3636C7.63474 20.359 7.6269 20.3538 7.61769 20.3496C7.44306 20.2674 7.26872 20.1794 7.09974 20.0874C7.09916 20.0867 7.09809 20.0862 7.09716 20.0859C6.78713 19.9151 6.48455 19.7262 6.19059 19.5193C1.9042 16.4998 0.873573 10.556 3.89323 6.26966C4.54984 5.33795 5.34444 4.56065 6.2303 3.94458C6.24122 3.93698 6.25213 3.92942 6.26295 3.92177C9.38458 1.77088 13.6233 1.62592 16.938 3.83617L16.226 4.86479C16.0281 5.1511 16.1499 5.35973 16.4964 5.32855L19.5888 5.0517C19.9357 5.02051 20.1432 4.72042 20.0499 4.38539L19.2194 1.39341C19.1265 1.05799 18.8885 1.01784 18.6903 1.3041L17.9768 2.33516C15.5442 0.702251 12.6267 0.0795996 9.73082 0.581755C9.43916 0.632233 9.15158 0.694016 8.86796 0.765934C8.86577 0.766323 8.86401 0.766567 8.86226 0.766957C8.85129 0.769637 8.84019 0.773194 8.82951 0.776166C6.33238 1.41743 4.15366 2.87386 2.59901 4.95186C2.5859 4.9674 2.5724 4.98261 2.56003 4.99951C2.50833 5.06914 2.45702 5.14038 2.40679 5.21161C2.32464 5.32835 2.24366 5.44802 2.16619 5.56769C2.15649 5.58211 2.14909 5.59678 2.14061 5.61135C0.857689 7.59936 0.238887 9.8977 0.345009 12.2375C0.345253 12.2452 0.344814 12.253 0.345009 12.2609C0.35529 12.4895 0.373416 12.7212 0.398022 12.9493C0.399337 12.964 0.402602 12.978 0.405087 12.9927C0.430521 13.2221 0.462436 13.452 0.502438 13.6819C0.908996 16.0274 2.01543 18.138 3.67338 19.7803C3.67723 19.7841 3.68123 19.7883 3.68513 19.7923C3.68649 19.7938 3.688 19.7946 3.68932 19.796C4.13476 20.2353 4.61927 20.6417 5.14097 21.0091C6.50623 21.9712 8.02649 22.6071 9.65915 22.9C10.1545 22.9891 10.6277 22.6593 10.7166 22.1642C10.8054 21.6687 10.476 21.1951 9.98073 21.1063Z"
          fill="#9CA1A8"
        />
        <path
          d="M11.1077 4.38391C10.7002 4.38391 10.3702 4.71426 10.3702 5.12116V12.4662L17.0878 15.9389C17.1959 15.9949 17.3117 16.0212 17.4256 16.0212C17.6924 16.0212 17.9501 15.8759 18.0812 15.6224C18.268 15.2606 18.1266 14.8161 17.7648 14.6292L11.8444 11.5684V5.12116C11.8444 4.71426 11.5147 4.38391 11.1077 4.38391Z"
          fill="#9CA1A8"
        />
      </g>
      <defs>
        <clipPath id="clip0_0_280">
          <rect
            width="22.6667"
            height="22.6667"
            fill="white"
            transform="translate(0.333334 0.333344)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const TotalPortfolioIcon = ({ size = 24, color = "currentColor" }) => {
  return (
    <svg
      width="28"
      height="25"
      viewBox="0 0 17 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.5833 2.54251H12.0417V1.83416C12.0417 1.05286 11.4063 0.41748 10.625 0.41748H6.375C5.5937 0.41748 4.95832 1.05282 4.95832 1.83416V2.54248H1.41668C0.635342 2.54251 0 3.17786 0 3.95916V6.08416C0 6.86549 0.635342 7.50084 1.41668 7.50084H7.08336V7.14666C7.08336 6.95089 7.24177 6.79248 7.43753 6.79248H9.56253C9.7583 6.79248 9.91671 6.95089 9.91671 7.14666V7.50084H15.5834C16.3647 7.50084 17 6.86549 17 6.08416V3.95916C17 3.17786 16.3647 2.54251 15.5833 2.54251ZM10.625 2.54251H6.375V1.83416H10.625V2.54251Z"
        fill="#9CA1A8"
      />
      <path
        d="M16.8035 7.8825C16.6828 7.82266 16.5386 7.83651 16.4321 7.91743C16.1803 8.10801 15.887 8.20865 15.5833 8.20865H9.91668V9.27115C9.91668 9.46692 9.75827 9.62533 9.5625 9.62533H7.4375C7.24173 9.62533 7.08332 9.46692 7.08332 9.27115V8.20865H1.41668C1.113 8.20865 0.819719 8.10801 0.567906 7.91743C0.461025 7.83581 0.317156 7.82197 0.19643 7.8825C0.0761016 7.94236 0 8.06511 0 8.19969V13.167C0 13.9483 0.635342 14.5837 1.41668 14.5837H15.5834C16.3647 14.5837 17 13.9483 17 13.167V8.19969C17 8.06511 16.9239 7.94236 16.8035 7.8825Z"
        fill="#9CA1A8"
      />
    </svg>
  );
};

export const ChatIcon = ({ size = 24, color = "currentColor" }) => {
  return (
    <svg
      width="27"
      height="27"
      viewBox="0 0 27 27"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_0_244)">
        <path
          d="M3.40847 21.1322C2.5174 21.1322 1.64686 20.9048 0.857896 20.4618C0.451964 20.2528 0.29474 19.7298 0.537243 19.3363C1.34297 18.0488 1.63392 16.475 1.26502 14.9949C0.882648 13.4605 0.329393 12.1681 0.333353 10.5438C0.347082 4.84481 5.09054 0.224713 10.7837 0.335272C16.2826 0.446029 20.8144 5.0685 20.8145 10.5688C20.8145 17.7524 13.2861 22.7958 6.63988 20.0218C5.72379 20.7409 4.57233 21.1322 3.40847 21.1322ZM2.32572 19.3783C3.5777 19.7672 4.98579 19.4566 5.95125 18.5232C6.18913 18.2932 6.54496 18.2353 6.84344 18.378C12.5335 21.0986 19.2304 16.8344 19.2303 10.5688C19.2303 5.89343 15.4268 2.01319 10.7518 1.91906C5.93396 1.82336 1.92909 5.72532 1.91748 10.5476C1.91371 12.0905 2.51568 13.3235 2.84465 14.785C3.19124 16.3253 3.00867 17.954 2.32572 19.3783Z"
          fill="#9CA1A8"
        />
        <path
          d="M23.9224 26.9988C22.7586 26.9988 21.607 26.6074 20.6911 25.8885C17.1565 27.3637 12.9521 26.6919 10.054 24.1891C9.72294 23.9031 9.68637 23.403 9.97224 23.0719C10.2582 22.7409 10.7583 22.7042 11.0894 22.9902C13.6597 25.2099 17.4241 25.7092 20.4874 24.2447C20.7859 24.1019 21.1416 24.1598 21.3796 24.3899C22.345 25.3232 23.7532 25.634 25.0052 25.245C24.1995 23.5645 24.0879 21.6394 24.7122 19.8571C24.7179 19.841 24.724 19.8253 24.7306 19.8096C25.1866 18.7347 25.4163 17.5923 25.4135 16.4142C25.4085 14.3371 24.7175 12.4158 23.4152 10.8577C23.1347 10.522 23.1794 10.0226 23.515 9.74206C23.8506 9.46148 24.3502 9.50623 24.6307 9.84186C26.1512 11.661 26.9918 13.9937 26.9976 16.4104C27.001 17.7946 26.7324 19.1379 26.1994 20.4036C25.6395 22.0242 25.897 23.7594 26.7936 25.2028C27.0363 25.5963 26.8789 26.1194 26.4729 26.3286C25.684 26.7714 24.8133 26.9988 23.9224 26.9988Z"
          fill="#9CA1A8"
        />
        <path
          d="M10.5802 11.8643C11.2724 11.8643 11.8335 11.3035 11.8335 10.6116C11.8335 9.91982 11.2724 9.35899 10.5802 9.35899C9.88805 9.35899 9.32692 9.91982 9.32692 10.6116C9.32692 11.3035 9.88805 11.8643 10.5802 11.8643Z"
          fill="#9CA1A8"
        />
        <path
          d="M5.95843 11.8643C6.65061 11.8643 7.21174 11.3035 7.21174 10.6116C7.21174 9.91982 6.65061 9.35899 5.95843 9.35899C5.26625 9.35899 4.70513 9.91982 4.70513 10.6116C4.70513 11.3035 5.26625 11.8643 5.95843 11.8643Z"
          fill="#9CA1A8"
        />
        <path
          d="M15.1964 11.8643C15.8886 11.8643 16.4497 11.3035 16.4497 10.6116C16.4497 9.91982 15.8886 9.35899 15.1964 9.35899C14.5042 9.35899 13.9431 9.91982 13.9431 10.6116C13.9431 11.3035 14.5042 11.8643 15.1964 11.8643Z"
          fill="#9CA1A8"
        />
      </g>
      <defs>
        <clipPath id="clip0_0_244">
          <rect
            width="26.6667"
            height="26.6667"
            fill="white"
            transform="translate(0.333332 0.333328)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const LeaderBoardIcon = ({ size = 24, color = "currentColor" }) => {
  return (
    <svg
      width="28"
      height="27"
      viewBox="0 0 28 27"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_0_269)">
        <path
          d="M13.1558 4.62644L11.1093 0.751043C10.9737 0.494115 10.707 0.333313 10.4164 0.333313H4.25815C3.98346 0.333313 3.72883 0.477136 3.58699 0.712384C3.44521 0.947631 3.4369 1.23998 3.56521 1.48291L7.76613 9.43843C8.89488 8.61755 10.1912 8.01383 11.5936 7.69035L13.1558 4.62644Z"
          fill="#9CA1A8"
        />
        <path
          d="M23.7416 0.333313H17.5834C17.2887 0.333313 17.0191 0.498556 16.8853 0.761022L13.4838 7.43243C13.6452 7.42506 13.8073 7.42083 13.9704 7.42083C16.3526 7.42083 18.5531 8.21304 20.3229 9.54741L24.4397 1.47288C24.5636 1.22995 24.5523 0.940056 24.4099 0.707578C24.2673 0.475047 24.0143 0.333313 23.7416 0.333313Z"
          fill="#9CA1A8"
        />
        <path
          d="M13.9699 8.98849C9.00399 8.98849 4.96393 13.0286 4.96393 17.9945C4.96393 22.9604 9.00399 27.0004 13.9699 27.0004C18.9358 27.0004 22.9759 22.9604 22.9759 17.9945C22.9759 13.0286 18.9358 8.98849 13.9699 8.98849ZM13.9699 23.9342C10.7396 23.9342 8.11153 21.3062 8.11153 18.0759C8.11153 14.8455 10.7396 12.2175 13.9699 12.2175C17.2002 12.2175 19.8283 14.8455 19.8283 18.0759C19.8283 21.3062 17.2002 23.9342 13.9699 23.9342Z"
          fill="#9CA1A8"
        />
        <path
          d="M17.9422 19.7222C18.8499 17.5324 17.8105 15.0214 15.6207 14.1138C13.4309 13.2061 10.9199 14.2455 10.0123 16.4352C9.10459 18.625 10.144 21.136 12.3337 22.0437C14.5235 22.9514 17.0345 21.912 17.9422 19.7222Z"
          fill="#9CA1A8"
        />
      </g>
      <defs>
        <clipPath id="clip0_0_269">
          <rect
            width="26.6667"
            height="26.6667"
            fill="white"
            transform="translate(0.666668 0.333313)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const PromoIcon = ({ size = 24, color = "currentColor" }) => {
  return (
    <svg
      width="29"
      height="28"
      viewBox="0 0 29 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.4411 0.334198C17.9881 0.334198 17.6208 0.701479 17.6208 1.15451V1.75301L8.87083 6.35824V16.732L17.6208 21.3372V21.9357C17.6208 22.3888 17.9881 22.7561 18.4411 22.7561C18.8942 22.7561 19.2615 22.3888 19.2615 21.9357V1.15451C19.2615 0.701479 18.8942 0.334198 18.4411 0.334198Z"
        fill="#9CA1A8"
      />
      <path
        d="M21.5691 8.16107L20.9026 7.71674V15.373L21.5691 14.9286C22.1777 14.5229 22.5432 13.8399 22.5432 13.1085V9.98123C22.5432 9.24979 22.1777 8.5668 21.5691 8.16107Z"
        fill="#9CA1A8"
      />
      <path
        d="M0.666668 9.35809V13.7331C0.666668 15.0922 1.76846 16.194 3.1276 16.194H7.22916V6.89716H3.1276C1.76846 6.89716 0.666668 7.99894 0.666668 9.35809Z"
        fill="#9CA1A8"
      />
      <path
        d="M1.99145 24.8866C1.75919 26.048 2.64748 27.1316 3.8319 27.1316C4.72659 27.1316 5.49686 26.5001 5.67235 25.6228L7.22996 17.8347H3.40184L1.99145 24.8866Z"
        fill="#9CA1A8"
      />
      <path
        d="M27.8464 10.7247H25.112C24.6589 10.7247 24.2917 11.092 24.2917 11.545C24.2917 11.998 24.6589 12.3653 25.112 12.3653H27.8464C28.2994 12.3653 28.6667 11.998 28.6667 11.545C28.6667 11.092 28.2994 10.7247 27.8464 10.7247Z"
        fill="#9CA1A8"
      />
      <path
        d="M23.8566 7.58116C24.0831 7.97349 24.5848 8.10797 24.9772 7.88139L27.3452 6.51421C27.7375 6.28769 27.872 5.78599 27.6454 5.39366C27.4189 5.00133 26.9172 4.86686 26.5249 5.09343L24.1568 6.46061C23.7645 6.68708 23.6301 7.18878 23.8566 7.58116Z"
        fill="#9CA1A8"
      />
      <path
        d="M27.3452 16.5765L24.9772 15.2093C24.5848 14.9828 24.0831 15.1172 23.8566 15.5096C23.6301 15.9019 23.7645 16.4036 24.1568 16.6301L26.5249 17.9973C26.9172 18.2238 27.4189 18.0894 27.6454 17.6971C27.8719 17.3047 27.7375 16.803 27.3452 16.5765Z"
        fill="#9CA1A8"
      />
    </svg>
  );
};

export const WebinarsIcon = ({ size = 24, color = "currentColor" }) => {
  return (
    <svg
      width="27"
      height="23"
      viewBox="0 0 27 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.52513 1.78011H22.5631C22.8952 1.78011 23.2189 1.82618 23.5331 1.90277C23.1842 0.803591 22.167 0 20.9536 0H6.04495C4.8243 0 3.80171 0.813762 3.45946 1.92311C3.80231 1.83097 4.15953 1.78011 4.52513 1.78011Z"
        fill="#9CA1A8"
      />
      <path
        d="M2.7282 4.78739H24.269C24.6292 4.78739 24.9762 4.84184 25.3041 4.94117C25.2521 4.78859 25.1916 4.6384 25.115 4.49659C24.6059 3.55957 23.6281 2.97797 22.5625 2.97797H4.52446C3.4558 2.97797 2.47629 3.56256 1.96829 4.50377C1.89709 4.63601 1.84024 4.77483 1.79058 4.91664C2.08976 4.83526 2.40329 4.78799 2.7282 4.78799V4.78739Z"
        fill="#9CA1A8"
      />
      <path
        d="M24.2675 5.98315H2.72675C1.40499 5.98315 0.333332 7.05481 0.333332 8.37657V19.7453C0.333332 21.0671 1.40499 22.1387 2.72675 22.1387H24.2675C25.5893 22.1387 26.6609 21.0671 26.6609 19.7453V8.37657C26.6609 7.05481 25.5893 5.98315 24.2675 5.98315ZM17.6342 15.6155L12.249 18.7245C11.9677 18.8867 11.6596 18.9681 11.3514 18.9681C11.0433 18.9681 10.7345 18.8873 10.4539 18.7245C9.89205 18.4002 9.55637 17.8192 9.55637 17.17V10.9519C9.55637 10.3027 9.89205 9.72167 10.4539 9.39737C11.0158 9.07306 11.6871 9.07306 12.249 9.39737L17.6342 12.5064C18.196 12.8307 18.5317 13.4123 18.5317 14.0609C18.5317 14.7096 18.196 15.2912 17.6342 15.6155Z"
        fill="#9CA1A8"
      />
    </svg>
  );
};

export const MarketIcon = ({ size = 24, color = "currentColor" }) => {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_0_299)">
        <path
          d="M13.0003 29.9921C6.37356 29.1637 1.16783 23.958 0.340244 17.3329C0.27538 16.821 0.675279 16.3668 1.19304 16.3668H4.66716C5.08683 16.3668 5.44438 16.6698 5.51492 17.0828C6.18304 21.0395 9.29118 24.1485 13.2505 24.8175C13.6634 24.8879 13.9664 25.2456 13.9664 25.6652V29.1393C13.9664 29.6505 13.5232 30.0544 13.0003 29.9921Z"
          fill="#9CA1A8"
        />
        <path
          d="M4.66715 14.4188H1.19304C0.674986 14.4188 0.275431 13.9642 0.340238 13.4527C1.25011 6.16362 7.47819 0.666687 14.8259 0.666687C18.0902 0.666687 21.1849 1.73098 23.776 3.74463C24.1881 4.06614 24.219 4.669 23.8566 5.03136L21.4006 7.48817C21.1035 7.78613 20.6368 7.82309 20.2943 7.58048C18.6819 6.43138 16.7908 5.82371 14.8259 5.82371C10.2018 5.82371 6.28537 9.1375 5.51485 13.7028C5.44437 14.1157 5.08682 14.4188 4.66715 14.4188Z"
          fill="#9CA1A8"
        />
        <path
          d="M15.9167 29.1424V25.6683C15.9167 25.2486 16.2197 24.8911 16.6326 24.8206C21.1979 24.05 24.5117 20.1336 24.5117 15.5095C24.5117 13.5446 23.904 11.6535 22.7549 10.0411C22.5115 9.69947 22.5501 9.2311 22.8473 8.9348L25.3041 6.47885C25.6618 6.12113 26.2665 6.14382 26.5908 6.55942C28.6044 9.15053 29.6687 12.2453 29.6687 15.5095C29.6687 22.8572 24.1717 29.0853 16.8827 29.9952C16.3542 30.0582 15.9167 29.6476 15.9167 29.1424Z"
          fill="#9CA1A8"
        />
        <path
          d="M11.563 11.8978C11.563 11.4231 11.1782 11.0383 10.7035 11.0383H8.9845C8.50983 11.0383 8.125 11.4231 8.125 11.8978V18.7738C8.125 19.2485 8.50983 19.6333 8.9845 19.6333H10.7035C11.1782 19.6333 11.563 19.2485 11.563 18.7738V11.8978Z"
          fill="#9CA1A8"
        />
        <path
          d="M16.7156 18.7741V10.179C16.7156 9.70435 16.3307 9.31952 15.8561 9.31952H14.1371C13.6624 9.31952 13.2775 9.70435 13.2775 10.179V18.7741C13.2775 19.2487 13.6624 19.6336 14.1371 19.6336H15.8561C16.3308 19.6336 16.7156 19.2487 16.7156 18.7741Z"
          fill="#9CA1A8"
        />
        <path
          d="M21.8755 18.7733V15.3353C21.8755 14.8606 21.4907 14.4758 21.016 14.4758H19.297C18.8223 14.4758 18.4375 14.8606 18.4375 15.3353V18.7733C18.4375 19.248 18.8223 19.6328 19.297 19.6328H21.016C21.4907 19.6328 21.8755 19.248 21.8755 18.7733Z"
          fill="#9CA1A8"
        />
      </g>
      <defs>
        <clipPath id="clip0_0_299">
          <rect
            width="29.3333"
            height="29.3333"
            fill="white"
            transform="translate(0.333332 0.666687)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const TutorialsIcon = ({ size = 24, color = "currentColor" }) => {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M29.8333 26.375C29.8333 26.9511 29.3667 27.4167 28.7917 27.4167H8.80833C8.37708 28.6261 7.23125 29.5 5.875 29.5C4.51875 29.5 3.37292 28.6261 2.94167 27.4167H1.70833C1.13333 27.4167 0.666668 26.9511 0.666668 26.375C0.666668 25.799 1.13333 25.3334 1.70833 25.3334H2.94167C3.37292 24.124 4.51875 23.25 5.875 23.25C7.23125 23.25 8.37708 24.124 8.80833 25.3334H28.7917C29.3667 25.3334 29.8333 25.799 29.8333 26.375ZM13.1667 13.9323L18.3115 10.75L13.1615 7.56462L13.1667 13.9323ZM29.8333 3.45837V18.0417C29.8333 19.7646 28.4312 21.1667 26.7083 21.1667H3.79167C2.06875 21.1667 0.666668 19.7646 0.666668 18.0417V3.45837C0.666668 1.73546 2.06875 0.333374 3.79167 0.333374H26.7083C28.4312 0.333374 29.8333 1.73546 29.8333 3.45837ZM20.3938 10.75C20.3938 10.023 20.025 9.3615 19.4062 8.97816L14.2615 5.79587C13.6208 5.399 12.8115 5.38025 12.1521 5.74796C11.4927 6.11567 11.0833 6.81254 11.0833 7.56775V13.9323C11.0833 14.6875 11.4938 15.3855 12.1521 15.7521C12.4677 15.9282 12.8167 16.0146 13.1656 16.0146C13.5469 16.0146 13.9271 15.9105 14.2615 15.7042L19.4062 12.5209C20.024 12.1386 20.3927 11.4761 20.3927 10.749L20.3938 10.75Z"
        fill="#9CA1A8"
      />
    </svg>
  );
};

export const MoreIcon = ({ size = 24, color = "currentColor" }) => {
  return (
    <svg
      width="23"
      height="6"
      viewBox="0 0 23 6"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="3" cy="2.66667" r="2.66667" fill="#9CA1A8" />
      <circle cx="12.3333" cy="2.66667" r="2.66667" fill="#9CA1A8" />
      <circle cx="20.3333" cy="2.66667" r="2.66667" fill="#9CA1A8" />
    </svg>
  );
};

export const AssetsAddIcon2 = ({ size = 24, color = "currentColor" }) => {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="7.33325"
        y="0.333334"
        width="4"
        height="17.3333"
        fill="#9197A4"
      />
      <rect
        x="0.666626"
        y="11"
        width="4"
        height="17.3333"
        transform="rotate(-90 0.666626 11)"
        fill="#9197A4"
      />
    </svg>
  );
};

export const ThreebarIcon = ({ size = 24, color = "currentColor" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 72 38"
      width="40"
      height="40"
      role="img"
      aria-label="Three bar icon"
    >
      <rect width="50" height="50" fill="transparent" />

      <rect x="21" y="16" width="6" height="16" rx="3" fill="var(--fnt)" />

      <rect x="33" y="6" width="6" height="26" rx="3" fill="var(--fnt)" />

      <rect x="45" y="20" width="6" height="12" rx="3" fill="var(--fnt)" />
    </svg>
  );
};

export const SupportIcon = ({ size = 24, color = "currentColor" }) => {
  return (
    <svg
      width="22"
      height="19"
      viewBox="0 0 22 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20.2689 14.3024C22.3578 11.3715 22.0385 7.35591 19.1852 4.7402C17.8815 3.5451 16.2195 2.80111 14.4242 2.59333C14.413 2.57957 14.4016 2.56593 14.389 2.55288C12.8272 0.930493 10.5833 0 8.23283 0C3.75985 0 0 3.33273 0 7.6C0 9.09614 0.46474 10.5304 1.34756 11.7691L0.114296 15.6411C0.0367756 15.8845 0.113029 16.1505 0.307631 16.3159C0.502571 16.4816 0.777564 16.5134 1.00476 16.3978L4.75524 14.4908C5.52545 14.8224 6.3422 15.0401 7.188 15.1391C8.81955 16.8548 11.0755 17.7333 13.3836 17.7333C14.5834 17.7333 15.7788 17.4888 16.861 17.0241L20.6117 18.9312C20.7025 18.9774 20.8008 19 20.8986 19C21.326 19 21.6324 18.5835 21.5021 18.1744L20.2689 14.3024ZM5.01085 13.2164C4.83347 13.1322 4.62713 13.135 4.45212 13.224L1.78085 14.5823L2.65316 11.8435C2.71666 11.6441 2.67761 11.4262 2.54874 11.2613C1.70996 10.1876 1.26658 8.9216 1.26658 7.6C1.26658 4.1078 4.39162 1.26667 8.23283 1.26667C9.77968 1.26667 11.2688 1.73529 12.4768 2.57919C8.40872 2.98824 5.15077 6.16563 5.15077 10.1333C5.15077 11.3674 5.4671 12.5555 6.06349 13.6199C5.70241 13.5123 5.35074 13.3779 5.01085 13.2164ZM17.1643 15.7573C16.9918 15.6696 16.7853 15.6643 16.6056 15.7498C15.6182 16.2188 14.5041 16.4667 13.3836 16.4667C9.54239 16.4667 6.41736 13.6255 6.41736 10.1333C6.41736 6.64113 9.54239 3.8 13.3836 3.8C17.2248 3.8 20.3498 6.64113 20.3498 10.1333C20.3498 11.4549 19.9065 12.721 19.0676 13.7946C18.9388 13.9595 18.8998 14.1774 18.9632 14.3768L19.8355 17.1156L17.1643 15.7573Z"
        fill="white"
      />
    </svg>
  );
};

export const QuestionIcon = ({ size = 24, color = "currentColor" }) => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="8.99986" cy="8.99998" r="6.42857" fill="black" />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M18 9C18 13.9705 13.9705 18 9 18C4.02943 18 0 13.9705 0 9C0 4.02943 4.02943 0 9 0C13.9705 0 18 4.02943 18 9ZM9 5.175C8.44083 5.175 7.9875 5.62831 7.9875 6.1875C7.9875 6.56029 7.68528 6.8625 7.3125 6.8625C6.93971 6.8625 6.6375 6.56029 6.6375 6.1875C6.6375 4.88272 7.69527 3.825 9 3.825C10.3047 3.825 11.3625 4.88272 11.3625 6.1875C11.3625 6.82726 11.1074 7.4088 10.6947 7.8336C10.6116 7.91901 10.5324 7.99821 10.4568 8.07372C10.2626 8.26776 10.0924 8.43777 9.94311 8.62965C9.74601 8.88291 9.675 9.06912 9.675 9.225V9.9C9.675 10.2728 9.37278 10.575 9 10.575C8.62722 10.575 8.325 10.2728 8.325 9.9V9.225C8.325 8.63532 8.5995 8.15796 8.87778 7.80048C9.08361 7.53597 9.34236 7.27767 9.55242 7.06811C9.61578 7.00489 9.67464 6.9461 9.7263 6.89289C9.90414 6.70989 10.0125 6.46204 10.0125 6.1875C10.0125 5.62831 9.55917 5.175 9 5.175ZM9 13.5C9.49707 13.5 9.9 13.0971 9.9 12.6C9.9 12.1029 9.49707 11.7 9 11.7C8.50293 11.7 8.1 12.1029 8.1 12.6C8.1 13.0971 8.50293 13.5 9 13.5Z"
        fill="#8F929B"
      />
    </svg>
  );
};

export const SoundOffIcon = ({ size = 24, color = "currentColor" }) => {
  return (
    <svg
      width="26"
      height="24"
      viewBox="0 0 26 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0 15.6784V7.94659C0 7.70936 0.192314 7.51705 0.429546 7.51705H6.44318L13.9602 0V23.625L6.44318 16.108H0.429545C0.192314 16.108 0 15.9156 0 15.6784Z"
        fill="#8E929C"
      />
      <path
        d="M22.2643 12.8865L25.6095 9.54116C25.8272 9.32356 25.8272 8.97174 25.6095 8.75414C25.3919 8.53654 25.04 8.53654 24.8224 8.75414L21.4771 12.0994L18.1319 8.75414C17.9142 8.53654 17.5625 8.53654 17.3449 8.75414C17.1272 8.97174 17.1272 9.32356 17.3449 9.54116L20.6901 12.8865L17.3449 16.2318C17.1272 16.4494 17.1272 16.8012 17.3449 17.0188C17.4534 17.1273 17.5959 17.1819 17.7384 17.1819C17.8809 17.1819 18.0234 17.1273 18.1319 17.0188L21.4771 13.6735L24.8224 17.0188C24.931 17.1273 25.0735 17.1819 25.2159 17.1819C25.3584 17.1819 25.5009 17.1273 25.6095 17.0188C25.8272 16.8012 25.8272 16.4494 25.6095 16.2318L22.2643 12.8865Z"
        fill="#82858E"
      />
    </svg>
  );
};

export const SoundOnIcon = ({ size = 24, color = "currentColor" }) => {
  return (
    <svg
      width="29"
      height="24"
      viewBox="0 0 29 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0 15.6784V7.94659C0 7.70936 0.192314 7.51705 0.429546 7.51705H6.44318L13.9602 0V23.625L6.44318 16.108H0.429545C0.192314 16.108 0 15.9156 0 15.6784Z"
        fill="#8E929C"
      />
      <path
        d="M24.5964 2.18765C24.3462 1.93745 23.9409 1.93745 23.6906 2.18765C23.4404 2.43785 23.4404 2.84329 23.6906 3.09349C27.9038 7.30671 27.9038 14.1623 23.6906 18.3756C23.4404 18.6258 23.4404 19.0312 23.6906 19.2814C23.9408 19.5316 24.3461 19.5316 24.5964 19.2814C29.3095 14.5689 29.3095 6.90006 24.5964 2.18765Z"
        fill="#8E929C"
      />
      <path
        d="M21.345 5.43875C21.0948 5.18855 20.6894 5.18855 20.4391 5.43875C20.1889 5.68895 20.1889 6.09439 20.4391 6.34459C22.8595 8.76495 22.8595 12.7036 20.4391 15.1245C20.1889 15.3747 20.1889 15.7801 20.4391 16.0303C20.6894 16.2805 21.0947 16.2805 21.345 16.0303C24.2652 13.1101 24.2652 8.35886 21.345 5.43875Z"
        fill="#8E929C"
      />
      <path
        d="M17.1877 8.68979C16.9374 8.93999 16.9374 9.34599 17.1877 9.59563C17.8156 10.2223 17.8181 11.2423 17.1877 11.8727C16.9374 12.1229 16.9374 12.5283 17.1877 12.7785C17.4379 13.0287 17.8432 13.0287 18.0935 12.7785C19.2323 11.6397 19.2145 9.8095 18.0935 8.68979C17.8433 8.4395 17.4379 8.4395 17.1877 8.68979Z"
        fill="#8E929C"
      />
    </svg>
  );
};

export const SettingsIcon = ({ size = 24, color = "currentColor" }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_34_6951)">
        <path
          d="M22.3286 9.24722L20.478 9.01195C20.3254 8.54241 20.1374 8.08959 19.9178 7.65942L21.0607 6.18778C21.5234 5.59223 21.4692 4.75158 20.9406 4.2397L19.3902 2.68931C18.8734 2.15578 18.0328 2.10262 17.4362 2.5643L15.9666 3.70716C15.5364 3.48764 15.0836 3.29962 14.613 3.14705L14.3778 1.29938C14.2892 0.558141 13.6602 0 12.915 0H10.71C9.96483 0 9.33581 0.558141 9.24722 1.29642L9.01195 3.14705C8.54142 3.29962 8.08861 3.48666 7.65844 3.70716L6.18778 2.5643C5.59322 2.10262 4.75256 2.15578 4.2397 2.68439L2.68931 4.2338C2.15578 4.75158 2.10164 5.59223 2.5643 6.18877L3.70716 7.65942C3.48666 8.08959 3.29963 8.54241 3.14705 9.01195L1.29938 9.24722C0.558141 9.33581 0 9.96483 0 10.71V12.915C0 13.6602 0.558141 14.2892 1.29642 14.3778L3.14705 14.613C3.29963 15.0826 3.48764 15.5354 3.70716 15.9656L2.5643 17.4372C2.10164 18.0328 2.15578 18.8734 2.68439 19.3853L4.23478 20.9357C4.75256 21.4682 5.59224 21.5214 6.18877 21.0597L7.65942 19.9169C8.08959 20.1374 8.54241 20.3254 9.01195 20.477L9.24722 22.3237C9.33581 23.0669 9.96483 23.625 10.71 23.625H12.915C13.6602 23.625 14.2892 23.0669 14.3778 22.3286L14.613 20.478C15.0826 20.3254 15.5354 20.1374 15.9656 19.9178L17.4372 21.0607C18.0328 21.5234 18.8734 21.4692 19.3853 20.9406L20.9357 19.3902C21.4692 18.8724 21.5234 18.0328 21.0607 17.4362L19.9178 15.9656C20.1383 15.5354 20.3264 15.0826 20.478 14.613L22.3246 14.3778C23.0659 14.2892 23.624 13.6602 23.624 12.915V10.71C23.625 9.96483 23.0669 9.33581 22.3286 9.24722ZM11.8125 16.7344C9.09858 16.7344 6.89063 14.5264 6.89063 11.8125C6.89063 9.09858 9.09858 6.89062 11.8125 6.89062C14.5264 6.89062 16.7344 9.09858 16.7344 11.8125C16.7344 14.5264 14.5264 16.7344 11.8125 16.7344Z"
          fill="#5C606C"
        />
      </g>
      <defs>
        <clipPath id="clip0_34_6951">
          <rect width="23.625" height="23.625" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
